import CheckBox from '@app/components/CheckBox'
import MentionEditor from '@app/components/MentionEditor'
import { IComment } from '@app/models/Comment'
import { bindFunctions } from '@app/utils/class'
import { EditorState } from 'draft-js'
import * as React from 'react'
import { Button } from 'reactstrap'

interface ICommentItemEditBodyProps {
  cancelEdit: (feedItemId: string, commentId: string) => void
  item: IComment
  saveEditComment: (feedItemId: string, comment: IComment) => void
  setIsPublic: (
    feedItemId: string,
    commentId: string,
    isPublic: boolean,
  ) => void
  setMarkup: (
    feedItemId: string,
    commentId: string,
    markupState: EditorState,
  ) => void
}

export default class CommentItemEditBody extends React.PureComponent<
  ICommentItemEditBodyProps
> {
  constructor(props: ICommentItemEditBodyProps) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    const editState = this.props.item.editState

    if (!editState) {
      return null
    }

    return (
      <div className='comment-item-edit-body'>
        <div className='pt-2'>
          <MentionEditor
            compact
            id={this.props.item.id}
            editorState={editState.markupState}
            onChange={this._onChangeMarkup}
          />
        </div>
        <div className='comment-item-edit-footer py-2 d-flex justify-content-between align-items-center'>
          <div>
            <CheckBox
              value={editState.isPublic}
              onChange={this._onChangeIsPublic}
            >
              Make public
            </CheckBox>
          </div>
          <div>
            <Button
              color='link'
              className='mr-2'
              disabled={this.props.item.isSaving}
              onClick={this._cancelEdit}
              size='sm'
            >
              Cancel
            </Button>
            <Button
              color='primary'
              disabled={this.props.item.isSaving}
              onClick={this._saveEdit}
              size='sm'
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    )
  }

  private _cancelEdit() {
    this.props.cancelEdit(this.props.item.parentId, this.props.item.id)
  }

  private _onChangeIsPublic(newIsPublic: boolean) {
    this.props.setIsPublic(
      this.props.item.parentId,
      this.props.item.id,
      newIsPublic,
    )
  }

  private _onChangeMarkup(newMarkupState: EditorState) {
    this.props.setMarkup(
      this.props.item.parentId,
      this.props.item.id,
      newMarkupState,
    )
  }

  private _saveEdit() {
    this.props.saveEditComment(this.props.item.parentId, this.props.item)
  }
}
